import React from 'react';
import { useNavigate } from 'react-router-dom';

export type SubscriptionSuccessModalProps = {
  open: boolean;
  onClose: () => void;
  planName?: string;
};

const SubscriptionSuccessModal: React.FC<SubscriptionSuccessModalProps> = (props) => {
  const { open, onClose, planName = 'Sanctum' } = props;
  const navigate = useNavigate();

  const handleGoHome = () => {
    onClose();
    navigate('/');
  };

  if (!open) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        boxSizing: 'border-box',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Content */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: '80px',
          padding: '0 16px',
        }}
      >
        {/* Header with only logo */}
        <header
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 'calc(96px + env(safe-area-inset-top, 0px))',
            width: '100%',
            background: '#1A1A1C',
          }}
        >
          <img src="/main-logo-white.svg" alt="logo" width={159} height="auto" draggable={false} />
        </header>

        {/* Middle Section */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            gap: '24px',
          }}
        >
          <div
            style={{
              fontSize: '24px',
              fontFamily: 'Inter',
              fontWeight: 600,
              lineHeight: '32px',
              color: 'white',
              marginBottom: '8px',
            }}
          >
            Your subscription <br /> is active.
          </div>
          <div
            style={{
              fontSize: '15px',
              fontFamily: 'Inter',
              fontWeight: 400,
              lineHeight: '21px',
              color: '#B7BDCB',
            }}
          >
            You now have full access to {planName}.
          </div>
        </div>

        {/* Go Home Button */}
        <button
          onClick={handleGoHome}
          style={{
            display: 'flex',
            height: '44px',
            width: '100%',
            maxWidth: '343px',
            margin: '0 auto 32px auto',
            background: '#5E84ED',
            borderRadius: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '15px',
            fontFamily: 'Inter',
            fontWeight: 600,
            lineHeight: '21px',
            cursor: 'pointer',
            outline: 'none',
            border: 'none',
          }}
        >
          Go to home
        </button>
      </div>
    </div>
  );
};

export default SubscriptionSuccessModal;
